// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import ApplicationFormController from "./application_form_controller"
application.register("application-form", ApplicationFormController)

import CollapseController from "./collapse_controller"
application.register("collapse", CollapseController)

import CookieConsentController from "./cookie_consent_controller"
application.register("cookie-consent", CookieConsentController)

import FlashMessageController from "./flash_message_controller"
application.register("flash-message", FlashMessageController)

import HelloController from "./hello_controller"
application.register("hello", HelloController)

import LandingController from "./landing_controller"
application.register("landing", LandingController)

import MultiUserVideoCallController from "./multi_user_video_call_controller"
application.register("multi-user-video-call", MultiUserVideoCallController)

import TestSessionController from "./test_session_controller"
application.register("test-session", TestSessionController)

import ChartController from "./chart_controller"
application.register("chart", ChartController)
